const AppendageStatus = {
	PENDING: 'PENDING',
	UPLOADED: 'UPLOADED',
	READY: 'READY',
	ERROR: 'ERROR',
};

module.exports = AppendageStatus;
